import React, { useCallback, useRef, useEffect, useState } from 'react';

const DEFAULT_STORAGE_KEY = 'console.layout.centerSplit.v1';

export default function VerticalSplitter({ onRatioChange, initialRatio = 0.4, storageKey }) {
    const key = storageKey || DEFAULT_STORAGE_KEY;
    const [ratio, setRatio] = useState(() => {
        try {
            const saved = localStorage.getItem(key);
            return saved ? parseFloat(saved) : initialRatio;
        } catch { return initialRatio; }
    });
    const dragging = useRef(false);
    const containerRef = useRef(null);

    useEffect(() => {
        localStorage.setItem(key, String(ratio));
        onRatioChange?.(ratio);
    }, [ratio, onRatioChange]);

    // Initial callback
    useEffect(() => { onRatioChange?.(ratio); }, []);

    const handleMouseDown = useCallback((e) => {
        e.preventDefault();
        dragging.current = true;
        document.body.style.cursor = 'row-resize';
        document.body.style.userSelect = 'none';
    }, []);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (!dragging.current) return;
            const splitter = document.querySelector('[data-vertical-splitter]');
            if (!splitter) return;
            const container = splitter.parentElement;
            if (!container) return;
            const rect = container.getBoundingClientRect();
            const newRatio = Math.max(0.15, Math.min(0.85, (e.clientY - rect.top) / rect.height));
            setRatio(newRatio);
        };
        const handleMouseUp = () => {
            dragging.current = false;
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);

    return (
        <div
            ref={containerRef}
            data-vertical-splitter
            onMouseDown={handleMouseDown}
            style={{
                height: 6, cursor: 'row-resize',
                background: '#E8EAED', borderRadius: 3,
                margin: '2px 0', flexShrink: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
        >
            <div style={{ width: 32, height: 2, background: '#BDC1C6', borderRadius: 1 }} />
        </div>
    );
}
